import React, { useEffect } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogTitle from "@material-ui/core/DialogTitle"
import LoginDialog from "../../components/LoginDialog"
import { makeStyles } from "@material-ui/core/styles"
import { Ridecell } from "@ridecell/web-sdk"

import useGlobalContext from "../../utils/customHooks/useGlobalContext"
import defaultLogo from "./defaultLogo"
import messages from "./messages"
import PopupModal from "../../utils/elements/PopupModal"

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    left: "41%",
    top: "20%",
    width: "300px",
  },
  mobileLogo: {
    top: "15%",
    left: "28%",
    position: "fixed",
  },
  mobileImg: {
    width: "65%",
  },
  imgLogo: {
    width: "100%",
  },
}))

const LoginComponents = ({ history, intl: { formatMessage } }) => {
  const classes = useStyles()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const {
    state: { tenantSettings, isAuthenticated },
    setAuthenticated,
    setMfaDialog,
  } = useGlobalContext()

  useEffect(() => {
    if (isAuthenticated) {
      history.push("/")
    }
  }, [])

  const mfaEnabled =
    tenantSettings.mfaEnabled && tenantSettings.mfaEnabledForStaff

  const login = async ({ username, password, deviceId }) =>
    new Promise((res, rej) => {
      Ridecell.login({
        email: username,
        password,
        ...(mfaEnabled && { deviceId: deviceId }),
      })
        .then(async (response) => {
          if (response["nonce"]) {
            setMfaDialog(true)
          } else if (!response["is_staff"]) {
            setAuthenticated(true)
            history.push("/")
          }
          res(response)
        })
        .catch((result) => {
          setAuthenticated(false)
          rej(result)
        })
    })

  return (
    <>
      <div className={isMobile ? classes.mobileLogo : classes.logo}>
        <img
          alt="company-logo"
          src={tenantSettings.serviceLogoUrl || defaultLogo}
          style={{ width: isMobile ? "65%" : "100%" }}
        />
      </div>
      <LoginDialog
        handleLogin={login}
        isMobile={isMobile}
        open={true}
        history={history}
      />
      <Dialog open={false}>
        <DialogTitle>{formatMessage(messages.logoutMessage)}</DialogTitle>
        <DialogActions>
          <Button color="primary" type="submit" variant="contained">
            {formatMessage(messages.logout)}
          </Button>
          <Button color="secondary" variant="contained">
            {formatMessage(messages.cancel)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default withRouter(injectIntl(LoginComponents))
